import React, { useEffect } from 'react';
import './HakkimizdaPage.css';

// Team member component
const TeamMember = ({ name, role, image, social }) => {
  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 hover:-translate-y-2 hover:shadow-xl">
      <div className="relative h-60 overflow-hidden">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
      </div>
      <div className="p-4 text-center">
        <h3 className="text-xl font-bold text-gray-800 mb-1">{name}</h3>
        <p className="text-secondary font-medium mb-3">{role}</p>
        <div className="flex justify-center space-x-3">
          {social.map((item, index) => (
            <a 
              key={index} 
              href={item.url} 
              target="_blank" 
              rel="noopener noreferrer"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-light hover:bg-secondary hover:text-white transition-colors"
              aria-label={item.name}
            >
              <i className={item.icon}></i>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};

// Value card component
const ValueCard = ({ icon, title, description }) => {
  return (
    <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-shadow">
      <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4 text-primary">
        <i className={`${icon} text-2xl`}></i>
      </div>
      <h3 className="text-xl font-bold mb-2 text-gray-800">{title}</h3>
      <p className="text-gray-600">{description}</p>
    </div>
  );
};

// Timeline item component
const TimelineItem = ({ year, title, description, isLeft }) => {
  return (
    <div className={`flex items-center w-full ${isLeft ? 'justify-start' : 'justify-end'}`}>
      <div className={`w-full md:w-5/12 ${!isLeft && 'order-1'}`}>
        <div className="p-6 bg-white rounded-xl shadow-md hover:shadow-lg transition-all ml-auto">
          <span className="text-secondary font-bold text-sm">{year}</span>
          <h3 className="text-xl font-bold mb-2">{title}</h3>
          <p className="text-gray-600">{description}</p>
        </div>
      </div>
      <div className="z-20 flex items-center order-1 shadow-xl w-8 h-8 rounded-full bg-secondary">
        <h1 className="mx-auto text-white font-semibold text-lg">✓</h1>
      </div>
      <div className={`w-full md:w-5/12 ${isLeft && 'order-1'}`}></div>
    </div>
  );
};

function HakkimizdaPage() {
  useEffect(() => {
    // Animation for elements when they come into view
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.animate-on-scroll').forEach(el => {
      observer.observe(el);
    });

    // Cleanup
    return () => observer.disconnect();
  }, []);

  const teamMembers = [
    {
      name: "ALİCEM YILMAAAAAAAAAAZ",
      role: "Kurucu & Baş Barista",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
      social: [
        { name: "twitter", icon: "fab fa-twitter", url: "#" },
        { name: "instagram", icon: "fab fa-instagram", url: "#" }
      ]
    },
    {
      name: "Zeynep Kaya",
      role: "Şef Barista",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
      social: [
        { name: "instagram", icon: "fab fa-instagram", url: "#" },
        { name: "linkedin", icon: "fab fa-linkedin", url: "#" }
      ]
    },
    {
      name: "Mehmet Demir",
      role: "Pasta Şefi",
      image: "https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80",
      social: [
        { name: "instagram", icon: "fab fa-instagram", url: "#" },
        { name: "facebook", icon: "fab fa-facebook", url: "#" }
      ]
    },
    {
      name: "Ayşe Yıldız",
      role: "Müşteri İlişkileri",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80",
      social: [
        { name: "twitter", icon: "fab fa-twitter", url: "#" },
        { name: "instagram", icon: "fab fa-instagram", url: "#" }
      ]
    }
  ];

  const ourValues = [
    {
      icon: "fas fa-seedling",
      title: "Sürdürülebilirlik",
      description: "Çevreye saygılı kaynaklardan temin edilen kahve çekirdekleri ve doğa dostu uygulamalar."
    },
    {
      icon: "fas fa-handshake",
      title: "Adil Ticaret",
      description: "Kahve çiftçileriyle adil ticaret ilkelerine dayalı, etik iş ortaklıkları kuruyoruz."
    },
    {
      icon: "fas fa-heart",
      title: "Tutkulu Hizmet",
      description: "Her fincan kahveyi tutkuyla hazırlıyor, müşterilerimize en iyi deneyimi sunuyoruz."
    },
    {
      icon: "fas fa-users",
      title: "Topluluk",
      description: "Misafirlerimiz ve çalışanlarımızla bir aile olmayı, sıcak bir ortam yaratmayı önemsiyoruz."
    }
  ];

  const historyTimeline = [
    {
      year: "2010",
      title: "İlk Adım",
      description: "Küçük bir kahve standı olarak yolculuğumuza başladık."
    },
    {
      year: "2012",
      title: "İlk Kafemiz",
      description: "Artan ilgi üzerine ilk resmi mağazamızı şehir merkezinde açtık."
    },
    {
      year: "2015",
      title: "Genişleme",
      description: "Üç yeni şube daha açarak daha fazla kahve severe ulaştık."
    },
    {
      year: "2018",
      title: "Özel Kavurma",
      description: "Kendi kahve kavurma tesisimizi kurarak özgün aromalar geliştirdik."
    },
    {
      year: "2022",
      title: "Bugün",
      description: "10 şube ve online sipariş platformumuzla tüm ülkeye hizmet veriyoruz."
    }
  ];

  return (
    <div className="bg-light min-h-screen pt-16 sm:pt-20 md:pt-24 pb-12">
      {/* Hero Section with parallax effect */}
      <div className="relative h-80 md:h-96 lg:h-[500px] overflow-hidden bg-fixed bg-center bg-cover bg-no-repeat mb-12" 
           style={{ backgroundImage: "url('https://images.unsplash.com/photo-1525193612562-0ec53b0e5d7c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80')" }}>
        <div className="absolute inset-0 bg-dark/50"></div>
        <div className="absolute inset-0 flex items-center justify-center p-5">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-playfair font-bold text-white mb-4 parallax-title">Hikayemiz</h1>
            <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto font-light">
              Kahve tutkusuyla başlayan, keyifli anılar biriktiren bir yolculuk
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* About Us / Our Story */}
        <section className="mb-16 md:mb-24">
          <div className="flex flex-col md:flex-row items-center md:items-start gap-8 md:gap-12">
            <div className="w-full md:w-1/2 animate-on-scroll opacity-0">
              <img 
                src="https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80" 
                alt="Kahve dükkânımız" 
                className="rounded-xl shadow-2xl w-full h-auto max-h-[600px] object-cover"
              />
            </div>
            <div className="w-full md:w-1/2 animate-on-scroll opacity-0 delay-300">
              <h2 className="text-3xl md:text-4xl font-bold mb-6 font-playfair text-dark border-b-2 border-secondary pb-2 inline-block">Bizim Hikayemiz</h2>
              <p className="text-gray-700 mb-4 leading-relaxed">
                2010 yılında küçük bir kahve standı olarak başlayan yolculuğumuz, bugün ülke genelinde birçok şubesi bulunan bir marka haline geldi. Kurucumuz Ahmet Yılmaz'ın kahveye olan tutkusu ve özel aromalar yaratma isteği, bizi her zaman en kaliteli ürünleri sunmaya yönlendirdi.
              </p>
              <p className="text-gray-700 mb-4 leading-relaxed">
                Her fincan kahvemizde, dünyanın dört bir yanından özenle seçilmiş çekirdeklerin uyumu ve barista ekibimizin ustalığı var. Misafirlerimize sadece kahve değil, unutulmaz bir deneyim sunmayı hedefliyoruz.
              </p>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Sürdürülebilirlik ve adil ticaret, iş modelimizin temelini oluşturuyor. Kahve çiftçilerine adil ücretler ödüyor, çevreye duyarlı uygulamalarla dünyamıza saygı duyuyoruz.
              </p>
              <div className="flex items-center space-x-4">
                <div className="w-16 h-16 rounded-full overflow-hidden">
                  <img 
                    src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80" 
                    alt="Kurucumuz" 
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <strong className="block text-dark text-lg">Ahmet Yılmaz</strong>
                  <span className="text-secondary">Kurucu & Baş Barista</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Mission & Vision */}
        <section className="mb-16 md:mb-24 bg-gradient-to-r from-primary/10 to-secondary/10 rounded-2xl p-8 md:p-12 animate-on-scroll opacity-0">
          <div className="flex flex-col md:flex-row gap-8 md:gap-12">
            <div className="w-full md:w-1/2">
              <h3 className="text-2xl md:text-3xl font-bold mb-4 text-primary font-playfair">Misyonumuz</h3>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Kahve dünyasının zengin kültürünü ve tatlarını, sürdürülebilir ve etik değerler çerçevesinde müşterilerimizle buluşturmak. Her fincan kahvede benzersiz bir deneyim sunarak, misafirlerimizin günlük yaşamlarına değer katmak.
              </p>
              <div className="bg-white p-4 rounded-lg shadow-md">
                <blockquote className="border-l-4 border-secondary pl-4 italic text-gray-600">
                  "İyi bir kahve günü değiştirir, harika bir kahve hayatı değiştirir."
                </blockquote>
              </div>
            </div>
            <div className="w-full md:w-1/2">
              <h3 className="text-2xl md:text-3xl font-bold mb-4 text-secondary font-playfair">Vizyonumuz</h3>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Türkiye'nin en yenilikçi ve misafir odaklı kahve zinciri olarak, kahve kültürünü zenginleştirmek ve dünya standartlarında kaliteyi herkes için erişilebilir kılmak. Aynı zamanda, tüm paydaşlarımız için sürdürülebilir bir büyüme modeli oluşturmayı hedefliyoruz.
              </p>
              <ul className="space-y-2">
                {['Kalite', 'Yenilikçilik', 'Sürdürülebilirlik', 'İnsan Odaklılık'].map((value, idx) => (
                  <li key={idx} className="flex items-center">
                    <span className="w-6 h-6 bg-secondary rounded-full flex items-center justify-center mr-2 text-white text-sm">✓</span>
                    <span className="text-gray-700">{value}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        {/* Core Values */}
        <section className="mb-16 md:mb-24 animate-on-scroll opacity-0">
          <h2 className="text-3xl md:text-4xl font-bold mb-10 font-playfair text-center text-dark">Değerlerimiz</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {ourValues.map((value, idx) => (
              <ValueCard key={idx} {...value} />
            ))}
          </div>
        </section>

        {/* History Timeline */}
        <section className="mb-16 md:mb-24 animate-on-scroll opacity-0">
          <h2 className="text-3xl md:text-4xl font-bold mb-10 font-playfair text-center text-dark">Tarihçemiz</h2>
          <div className="relative">
            {/* Vertical Line */}
            <div className="absolute hidden md:block left-1/2 w-0.5 h-full bg-gray-300 transform -translate-x-1/2"></div>
            <div className="space-y-8 relative">
              {historyTimeline.map((item, idx) => (
                <TimelineItem key={idx} {...item} isLeft={idx % 2 === 0} />
              ))}
            </div>
          </div>
        </section>

        {/* Our Team */}
        <section className="mb-16 md:mb-24 animate-on-scroll opacity-0">
          <h2 className="text-3xl md:text-4xl font-bold mb-10 font-playfair text-center text-dark">Ekibimiz</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {teamMembers.map((member, idx) => (
              <TeamMember key={idx} {...member} />
            ))}
          </div>
        </section>

        {/* Testimonials */}
        <section className="mb-16 md:mb-24 bg-white rounded-2xl p-8 md:p-12 shadow-lg animate-on-scroll opacity-0">
          <h2 className="text-3xl md:text-4xl font-bold mb-10 font-playfair text-center text-dark">Müşterilerimiz Ne Diyor?</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3].map((i) => (
              <div key={i} className="bg-light p-6 rounded-xl shadow-md">
                <div className="flex items-center mb-4">
                  <div className="text-secondary text-2xl">★★★★★</div>
                  <div className="ml-auto text-gray-500 text-sm">1 hafta önce</div>
                </div>
                <p className="text-gray-700 mb-4 italic">
                  "Bu kafede geçirdiğim her an için mutluyum. Kahveleri mükemmel, ortam huzur verici ve personel her zaman güleryüzlü. Kesinlikle en sevdiğim yer!"
                </p>
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full overflow-hidden bg-gray-300 mr-3">
                    <img 
                      src={`https://randomuser.me/api/portraits/${i % 2 === 0 ? 'women' : 'men'}/${i+10}.jpg`}
                      alt="Müşteri" 
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <strong className="block text-dark">Müşteri {i}</strong>
                    <span className="text-gray-500 text-sm">Düzenli Ziyaretçi</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Call To Action */}
        <section className="animate-on-scroll opacity-0">
          <div className="bg-gradient-to-r from-primary to-secondary rounded-2xl p-8 md:p-12 text-white text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 font-playfair">Kahve Dünyamızı Keşfedin</h2>
            <p className="text-white/90 mb-8 max-w-2xl mx-auto">
              Eşsiz kahve deneyimimizi tatmak ve bizimle tanışmak için sizi kafemize bekliyoruz. Özel fırsatlar ve etkinliklerden haberdar olmak için bizi takip edin!
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <a href="/menu" className="bg-white text-primary hover:bg-light hover:text-dark px-8 py-3 rounded-lg font-bold transition-colors shadow-lg">
                Menüyü İncele
              </a>
              <a href="/contact" className="bg-transparent hover:bg-white/20 text-white border-2 border-white px-8 py-3 rounded-lg font-bold transition-colors">
                Bize Ulaşın
              </a>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default HakkimizdaPage;
